<template>
  <div class="form-floating" >
    <input
      :class="{'form-control': true, 'is-invalid': error}"
      :type="type"
      :maxlength="inputlength"
      autocomplete="off"
      ref="value"
      :value="value"
      @input="$emit('input', $event.target.value)"
      :disabled="loading"
      :id="id"
      :placeholder="labelText"
      v-allow.number.phone
      @keyup="$emit('clearError')"
    />
    <label v-text="labelText" :for="id"></label>
    <slot name="icon"></slot>
  </div>
  <!-- <div class="input-group" :class="activeClass">
    <input
      class="form-control"
      :type="type"
      :maxlength="inputlength"
      autocomplete="off"
      ref="value"
      :value="value"
      @input="$emit('input', $event.target.value)"
      @focus="focusIn = true"
      @blur="focusIn = false"
      :disabled="loading"
      :id="id"
      v-allow.number.phone
      @keyup="$emit('clearError')"
    />
    <label v-text="labelText" @click="inputClick"></label>
    <slot name="icon" v-if="icon" class="icon"></slot>
  </div> -->
</template>

<script>
import { mapState } from "vuex";
export default {
  props: {
    inputlength: {
      type: Number,
    },
    labelText: {
      type: String,
    },
    value: {
      type: String,
    },
    type: {
      type: String,
      default: "text",
    },
    disabled: {
      type: String,
    },
    id: {
      type: String,
    },
    error: {
      type: Boolean
    },
  },
  // model: {
  //     prop: "name",
  //     event: "input"
  //   },
  data() {
    return {
      isLoading: false,
      focusIn: false,
      // icon: false,
    };
  },
  computed: {
    ...mapState({ state: (state) => state }),
    /*activeClass() {
      let check = "";
      if (this.value == "" || this.focusIn == true) {
        check = "";
      }
      if (this.value != "" && this.focusIn == true) {
      }
      if (this.focusIn == true || this.value != "") {
        check = "active";
      }
      if (this.focusIn == false && this.value != "") {
        check = "focus-active";
      }
      if (this.disabled == true) {
        check = "is-disabled";
      }
      return check;
    },*/
  /*  icon() {
      let temp = false;
      if (this.value == "" || this.focusIn) temp = false;
      if (this.value != "" && this.focusIn) temp = true;
      if (!this.focusIn && this.value != "") temp = true;

      return temp;
    },*/
    loading() {
      return this.state.sessions.loading;
    },
  },
  methods: {
    // inputClick() {
    //   if (this.disabled == false) {
    //     this.focusIn = true;
    //     this.$refs.value.focus();
    //   } else {
    //     return false;
    //   }
    // },
    updateModel(event) {
      this.$emit("input", event.target.value);
    },
  },
};
</script>

<style scoped lang="scss">
.form-floating {
  position: relative;

  .form-control, .form-select {
    height: calc(3.9rem + 2px);
    padding: 1rem .75rem;
    font-size: 0.875rem;
    color: $grey-100;
  }

   label {
    position: absolute;
    top: 0;
    left: 0;
    height: 100%;
    padding: 1.25rem .75rem;
    pointer-events: none;
    border: 1px solid transparent;
    transform-origin: 0 0;
    font-size: 0.875rem;
    transition:opacity .1s ease-in-out,transform .1s ease-in-out;
  }
  .form-control { 
    &::placeholder {
      color:transparent !important;
    }
    &.is-invalid{
      ~ label{
        color: $danger-dark !important;
      }
      &:focus{
        border-color:$danger-dark;
        box-shadow: 0 0 0 1px $danger-dark;
      }
    }    
    &:focus{
        border-color: $primary-color;
        outline: 0;
        box-shadow: 0 0 0 1px $primary-color;
        background-color:transparent;
      }
    &:focus,
    &:not(:placeholder-shown) {
        padding-top: 1.625rem;
        padding-bottom: .625rem;
      }
    &:-webkit-autofill {
        padding-top: 1.625rem;
        padding-bottom: .625rem;
      }
  }
    input[type="password"]{
      &.is-invalid{
        background-image:none
      }
    }  
  .form-select {
    padding-top: 1.625rem;
    padding-bottom: .625rem;
  }

  .form-control:focus ~ label{
    color:$primary-color;
  }
   .form-control:focus,
   .form-control:not(:placeholder-shown),
    .form-select {
    ~ label {
      transform: scale(.85) translateY(-.5rem) translateX(.15rem);
    }
  }
  .form-control:-webkit-autofill {
    ~ label {
      color:$grey-60;
      transform: scale(.85) translateY(-.5rem) translateX(.15rem);
    }
  }
  .icon{
      cursor: pointer;
      position: absolute;
      right: 0;
      top: 1.5rem;
      font-size: 1rem;
      color:$grey-30;
    }
}
/*
.input-box {
  .input-group {
    border-radius: 4px;
    padding: 22px 0 5px 3px;
    box-shadow: 0 0 0px 1px $grey-40;
    transition: 0.2s ease;
    background: $white-color;
    &.active {
      box-shadow: 0 0 0 2px $primary-color;
      background: $white-color;
      label {
        font-size: 12px;
        color: $primary-color;
        top: 10px;
      }
    }
    &.focus-active {
      box-shadow: 0 0 0px 1px $grey-40;
      background: $white-color;
      label {
        font-size: 12px;
        color: $grey-40;
        top: 10px;
      }
    }
    &.is-disabled {
      cursor: pointer;
    }
    .icon {
      font-size: 14px;
    }
  }
  label {
    color: $grey-60;
    font-size: 16px;
    display: block;
    margin-bottom: 0;
    position: absolute;
    top: 18px;
    left: 15px;
    cursor: text;
    transition: 0.2s ease;
  }
  .form-control {
    border: none;
    color: $black-color;
    background: transparent;
    &:focus {
      box-shadow: none;
    }
    &:disabled {
      label {
        cursor: no-drop;
      }
    }
  }
  // .form-control:disabled + label{ cursor: no-drop;}
}*/
</style>
